export default __webpack_public_path__ + "static/media/gif_.7b1f602d.webm";